export default process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_DEVELOPMENT === 'true';
